<template>
  <Patch>
    <h5 slot="title">標籤管理</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// TagManagement.vue?abd8afb4